<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ProjectEditorViewModel } from '@Projects/Components/ProjectEditor';
    

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ProjectEditor extends Vue
    {
        get vm(): ProjectEditorViewModel { return this.$props.viewModel as ProjectEditorViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
        get updating(): boolean { return this.vm.updating; }
        get deleting(): boolean { return this.vm.deleting; }
        get nameError(): string | null { return this.vm.nameError; }
        get descriptionError(): string | null { return this.vm.descriptionError; }

        get name(): string | null { return this.vm.name; }
        set name(val: string | null) { this.vm.name = val; }

        get description(): string | null { return this.vm.description; }
        set description(val: string | null) { this.vm.description = val; }


        handleFormSubmit()
        {
            this.vm.updating = true;
            this.$emit('update-project', this.vm.projectId, this.name, this.description);
        }

        handleDeleteProject()
        {
            this.vm.deleting = true;
            this.$emit('delete-project', this.vm.projectId);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form id="project-editor-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>* Name (2-100 characters):</label>
                                <input v-model.trim="name" type="text" class="form-control" required minlength="2" maxlength="100">
                                <div v-if="nameError" class="error">{{nameError}}</div>
                            </div>
                            <div class="form-group">
                                <label>Description (optional):</label>
                                <textarea v-model.trim="description" class="form-control"></textarea>
                                <div class="error">{{descriptionError}}</div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <div class="dropdown dropup">
                            <button :disabled="deleting || updating" type="button" class="btn btn-danger float-left" data-toggle="dropdown">{{ deleting ? 'Deleting...' : 'Delete' }}</button>
                            <div class="dropdown-menu" role="menu" style="padding: 10px;">
                                <a class="dropdown-item">Cancel</a>
                                <a class="dropdown-item" @click="handleDeleteProject">Confirm</a>
                            </div>
                        </div>
                        <div>
                            <button type="button" @click="close" :disabled="deleting || updating"  class="btn btn-secondary">Cancel</button>
                            <button type="submit" form="project-editor-form" :disabled="deleting || updating"  class="btn btn-primary">
                                {{updating ? 'Saving...' : 'Save'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

